import { SOGetEntity } from '../entity/so-get-entity';
import { SOGetCustomLogicRequirement } from '../custom-logic-requirement/so-get-custom-logic-requirement';
import { SOGetRelationship } from '../relationship/so-get-relationship';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetRelationshipAttribute implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public entity: SOGetEntity = null,
    public customLogicRequirement: SOGetCustomLogicRequirement = null,
    public relationship: SOGetRelationship = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetRelationshipAttribute(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'entity' in params ? params.entity : null,
      'customLogicRequirement' in params ? params.customLogicRequirement : null,
      'relationship' in params ? params.relationship : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
